// components/CustomAlert.js
import React, { useEffect, useState } from "react";
import { Alert } from "antd";
import { motion, AnimatePresence } from "framer-motion";
import styled from "styled-components";

const StyledAlertWrapper = styled.div`
  position: fixed;
  top: 80px;
  right: 30px;
  z-index: 9999;
  max-width: 300px;
`;

const CustomAlert = ({ messageText, type = "warning", duration = 4000 }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), duration);
    return () => clearTimeout(timer);
  }, [duration]);

  return (
    <StyledAlertWrapper>
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
          >
            <Alert
              message="Heads up!"
              description={messageText}
              type={type}
              showIcon
              closable
              onClose={() => setVisible(false)}
              style={{
                borderRadius: "12px",
                boxShadow: "0 6px 20px rgba(0, 0, 0, 0.1)",
              }}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </StyledAlertWrapper>
  );
};

export default CustomAlert;
